module.exports = __webpack_public_path__ + "media/whats_your_status_series_while_you_wait_to_hear/what-to-do-while-youre-waiting-to-hear-8350221c.jpg";